import './style/index.js';

import _Space from './Space';

export type { SpaceProps } from './Space';
export * from './type';

export const Space = _Space;
export default Space;
